import { api } from "./useApi";

export interface ValidarTokenResponse {
  valido: boolean;
  tipo?: 'bling' | 'tiny' | 'melhor_envio' | 'correios' | 'outros';
  tipo_outros?: string;
  motivo?: string;
  codigo?: string;
  erro?: string;
}

export interface SubmeterCredenciaisResponse {
  sucesso: boolean;
  mensagem?: string;
  codigo?: string;
  erro?: string;
}

export const credenciaisApi = () => ({
  /**
   * Valida um token de solicitação de credenciais
   * @param token Token da URL (não o hash)
   */
  validarToken: async (token: string): Promise<ValidarTokenResponse> => {
    try {
      const response = await api.post("/credenciais/validar_token", { token });
      return response.data;
    } catch (error: any) {
      return {
        valido: false,
        codigo: error.response?.data?.codigo || "erro_processamento",
        erro: error.response?.data?.erro || "Erro ao validar token"
      };
    }
  },

  /**
   * Submete credenciais para a solicitação
   * @param token Token da URL (não o hash)
   * @param usuario Usuário/email da credencial
   * @param senha Senha da credencial
   */
  submeterCredenciais: async (
    token: string,
    usuario: string,
    senha: string
  ): Promise<SubmeterCredenciaisResponse> => {
    try {
      const response = await api.post("/credenciais/submeter", {
        token,
        usuario,
        senha
      });
      return response.data;
    } catch (error: any) {
      return {
        sucesso: false,
        codigo: error.response?.data?.codigo || "erro_processamento",
        erro: error.response?.data?.erro || "Erro ao enviar credenciais"
      };
    }
  },
});
